module.exports = __webpack_public_path__ + "img/chicken.456b34d0.svg";